import { RestMethod } from "app/_helpers/ApiConfig/RestMethod";

// import { RestMethod } from '../../_helpers/ApiConfig/RestMethod'
// import FilterResponse from '../../_helpers/FilterResponse'
// import toastr from 'toastr'

export const BlockService = {
    getBlock,
    getBlockByID,
    createBlock,
    updateBlock,
    deleteBlock,
    getBlockAll
}


async function getBlock(projectID, filters) {
    let filter = filters ? filters : "filter[status]=1"
    try {
        const response = await RestMethod.GET('/global-configuration/block?' + filter);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function getBlockAll(projectID) {

    try {
        const response = await RestMethod.GET('/global-configuration/block/all-block');
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function getBlockByID(projectID, id) {
    try {
        const response = await RestMethod.GET('/global-configuration/block/' + id);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}


async function createBlock(projectID, data) {
    try {
        const response = await RestMethod.POST('/global-configuration/block', data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function updateBlock(projectID, id, data) {
    try {
        const response = await RestMethod.PUT('/global-configuration/block/' + id, data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}

async function deleteBlock(projectID, id, data) {
    try {
        const response = await RestMethod.DELETE('/global-configuration/block/' + id, data);
        return response.data;
    }
    catch (error) {
        console.log("error detected while fetching data from api");
        return null;
    }
}
